import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute } from '@org/ui';
import { AbilitiesList } from '../app/components/ability/abilities-list';

export const Route = createFileRoute('/abilities')({
  component: AbilitiesRoute,
});

function AbilitiesRoute() {
  return (
    <ProtectedRoute requiredPermissions={['admin:all', 'levels:write']}>
      <div className="space-y-6">
        <AbilitiesList />
      </div>
    </ProtectedRoute>
  );
}
